<template>
    <div>
		<div class="wrapper-tools-list"
			:style="`boder-color:${$appColors.gray}`"
			v-if="$route.name === 'tools-list'"
		>
			<tool-list
				:columns="columns"
				:rows="tools"
			></tool-list>
			<div class="buttons-container" v-if="emptyRows">
				<app-button
					class="btn-tool"
					text="Nueva Herramienta"
					icon="add"
					:style="`background-color:${$appColors.primary}`"
					@click="newToolForm"
				></app-button>
				<app-button
					icon="help_outline"
					class="btn-tool"
					text="Llenar data de ejemplo"
				></app-button>
			</div>
		</div>
		<router-view name="toolList"></router-view>
		<router-view name="toolType"></router-view>
		<router-view name="newToolForm"></router-view>
    </div>
</template>
<script>
import appButton from '@/components/shared/app-button';
import toolList from '@/components/configuration/tools/tools-list';
import { mapState } from 'vuex';

function created() {
	this.loadTools();
}

async function loadTools() {
	await this.$store.dispatch('tool/loadTools');
}

function emptyRows() {
	return this.tools.length === 0;
}

function newToolForm() {
	this.goTo('new-tool');
}

function data() {
	return {
		columns: [
			{
				id: 1,
				name: 'Nombre',
				value: 'name',
				checked: false,
				visible: true,
			},
			{
				id: 2,
				name: 'Descripción',
				value: 'description',
				checked: false,
				visible: true,
			},
			{
				id: 3,
				name: 'Tipo',
				value: 'type',
				checked: false,
				visible: true,
			},
			{
				id: 4,
				name: 'Acciones',
				checked: false,
				visible: true,
			},
		],
	};
}

export default {
	name: 'page-tools-list',
	components: {
		appButton,
		toolList,
	},
	computed: {
		...mapState('tool', {
			tools: state => state.tools,
		}),
		emptyRows,
	},
	created,
	data,
	methods: {
		loadTools,
		newToolForm,
	},
};
</script>

<style lang="scss" scoped>
	.wrapper-tools-list {
		background-color: white;
		border: 1px solid;
		box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);

		table.table-list {
			border: none;
			box-shadow: none;
		}

		.buttons-container {
			align-items: center;
			height: 200px;
			display: flex;
			justify-content: center;

			.btn-tool {
				border-radius: 4px;
				color: white;
				font-family: font(bold);
				margin: 0 10px;
				padding: 5px 10px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-tools-list.vue